import styled from "styled-components"

import { Banner, Popover, Text } from "@minuthq/meatball-ui-react"

import UpgradeIcon from "src/ui/icons/arrow-up-filled-upgrade.svg"
import { MCard } from "src/ui/MCard/MCard"
import { spacing } from "src/ui/spacing"

export type UpgradeIconPopoverProps = {
  className?: string
  ctaButton?: React.ReactNode
  hidden?: boolean
  text: string
  errorMsg: string | null
  description?: React.ReactNode
}

export function UpgradeIconPopover({
  className,
  ctaButton,
  hidden,
  text,
  errorMsg,
  description,
}: UpgradeIconPopoverProps) {
  if (hidden) {
    return null
  }

  return (
    <Box className={className}>
      <Popover
        trigger={<UpgradeIcon />}
        triggerType="hover"
        placement="bottom"
        offset={8}
      >
        <ContentBox>
          <InfoBox>
            <UpgradeIcon />
            <div>
              <Text variant="subtitleS" color="primary">
                {text}
              </Text>
              {description && description}
            </div>
          </InfoBox>
          {ctaButton}

          {!!errorMsg && (
            <ErrorBox>
              <Banner type="error" fullWidth>
                {errorMsg}
              </Banner>
            </ErrorBox>
          )}
        </ContentBox>
      </Popover>
    </Box>
  )
}

const Box = styled.div`
  display: inline-block;
`

const ContentBox = styled(MCard)`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: ${spacing.M};
  padding: ${spacing.M};
  max-width: 450px;
`
const ErrorBox = styled.div`
  grid-column: span 2;
`

const InfoBox = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: top;
  gap: ${spacing.XS};
`
